import React from 'react';
import {
  getGcPhotoGridClassName,
  getGcPhotoGridLayoutModifier,
  getPhotoImgAlt,
} from '../../utils/bookChapterPhoto';

/** Two GC photos: Prismic order = left/right; alt grid_1/grid_2 = column width + image styling. */
export default function GcReadPhotosPair({ photos }) {
  const items = (photos || []).filter((img) => img?.image?.fluid?.src);

  if (!items.length) return null;

  const layoutModifier = getGcPhotoGridLayoutModifier(items);

  return (
    <div className={`gc-read-photos-pair gc-read-photos-pair--${layoutModifier}`}>
      {items.map((img, idx) => {
        const col = idx + 1;

        return (
          <div
            className={`gc-read-photos-pair__media gc-read-photos-pair__media--col-${col} ${getGcPhotoGridClassName(
              img?.image?.alt,
              'media'
            )}`.trim()}
            key={`img-${img.image.fluid.src || idx}`}
          >
            <img
              src={img.image.fluid.src}
              alt={getPhotoImgAlt(img?.image?.alt, img?.caption?.text || '')}
              loading="lazy"
            />
          </div>
        );
      })}
      {items.map((img, idx) => {
        const col = idx + 1;

        return (
          <figcaption
            className={`gc-read-photos-pair__caption gc-read-photos-pair__caption--col-${col} ${getGcPhotoGridClassName(
              img?.image?.alt,
              'caption'
            )}`.trim()}
            key={`cap-${img.image.fluid.src || idx}`}
          >
            {img?.caption?.text || ''}
          </figcaption>
        );
      })}
    </div>
  );
}
